<template>
  <div class="top-container">
    <div v-if="!isFramed">
      <div class="top-nav">
        <!-- Left project section -->
        <div v-if="user" class="top-nav-item">
          <project-dropdown v-if="$can('viewProject')" />
        </div>

        <!-- Middle logo section -->
        <div :class="{ 'top-nav-item': true, 'center-logo': !user }">
          <a class="top-nav-logo" href="/">
            <img v-if="providerLogo" :src="providerLogo" />
            <img v-else src="@/img/xtreme-logo-color.svg" />
          </a>
        </div>

        <!-- Right user section -->
        <div class="top-nav-item top-nav-item-right" v-if="user">
          <metabase-link />
          <user-dropdown />
        </div>
      </div>
    </div>
    <project-inactive-banner
      v-if="showBanner && isProject"
    ></project-inactive-banner>
  </div>
</template>

<script>
import ProjectDropdown from '@/common/components/navigation/TopToolbarProjectDropdown'
import UserDropdown from '@/common/components/navigation/TopToolbarUserDropdown'
import MetabaseLink from '@/common/components/navigation/TopToolbarMetabaseLink'
import ProjectInactiveBanner from '@/common/components/ProjectInactiveBanner'

export default {
  components: {
    ProjectInactiveBanner,
    ProjectDropdown,
    UserDropdown,
    MetabaseLink
  },

  data() {
    return {
      providerLogo: xp.providerLogo // eslint-disable-line
    }
  },

  computed: {
    user() {
      return this.$store.state.app.user
    },

    showBanner() {
      return this.$store.getters.isProjectNotActive
    },

    isProject() {
      return !!this.$store.getters.projectId
    },
    isFramed() {
      return window.top !== window.self
    }
  }
}
</script>

<style scoped>
.top-nav {
  display: flex;
  background: #1d87c8;
  color: #fff;
  height: 64px;
}

.top-nav-logo {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.top-nav-logo img {
  height: 25px;
}

.top-nav-item {
  display: flex;
}

.top-nav-item:first-child,
.top-nav-item:last-child {
  flex: 1;
}

.top-nav-item-right > *:first-child {
  margin-left: auto;
}

.center-logo {
  justify-content: center;
}

.top-container {
  position: fixed;
  z-index: 2000;
  width: 100%;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/common/components/navigation/TopToolbar.vue